export default "__VITE_ASSET__CZqJQXZK__"